import { KineticModule } from '@kinetic-ui/data-layer';
import { useUserContext } from './useUserContext';
import { isNonNull } from 'kineticUtils';

/** Check if the user has a license for a single module */
export const useModuleLicense = (module: KineticModule | undefined) => {
  const { modules } = useUserContext();
  if (!module) {
    return true;
  }
  return modules.includes(module);
};

/** Check if the user has valid licenses for all the passed modules */
export const useAllModuleLicenses = (...modules: (KineticModule | undefined)[]) => {
  const { modules: userModules } = useUserContext();
  const nonNullModules = modules.filter(isNonNull);
  return nonNullModules.every((module) => userModules.includes(module));
};

/** Check if the user has a license for any of the passed modules */
export const useAnyModuleLicenses = (...modules: (KineticModule | undefined)[]) => {
  const { modules: userModules } = useUserContext();
  const nonNullModules = modules.filter(isNonNull);
  return nonNullModules.some((module) => userModules.includes(module));
};
